import type { GeoPoint } from '@rma/public/generic/domain/types';

export interface GoogleMapsStaticMapRequest {
  markerParameterStyle: string;
  showMarker: boolean;
  showPointOfInterest: boolean;
  dimensions: GoogleMapsStaticMapDimensions;
  locations?: GoogleMapsStaticMapLocations[];
  enableZoom?: boolean;
  cache?: string;
}

export interface GoogleMapsStaticMapDimensions {
  height: number;
  width: number;
  scale: number;
  zoom: number;
}

export interface GoogleMapsStaticMapLocations {
  coords?: GeoPoint;
  postcode?: string;
  state?: string;
  streetAddress?: string;
  suburb?: string;
  country?: string;
  markerImageUrl?: string;
}

export interface GoogleStaticMapConfig {
  width: number;
  height: number;
  scale: number;
  zoom: number;
  showPoi: 'on' | 'off';
  clickToInteractive: boolean;
  showMarkers: boolean;
  enableZoom: boolean;
  lazy: boolean;
  class?: string;
  markerParameterStyle?: string;
  cache?: string;
}

export const DEFAULT_GOOGLE_STATIC_MAP_CONFIG: GoogleStaticMapConfig = {
  height: 200,
  width: 640,
  zoom: 17,
  scale: 1,
  showPoi: 'off',
  clickToInteractive: true,
  showMarkers: true,
  lazy: true,
  enableZoom: true,
  class: 'w-full object-cover object-center',
};
